(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/package-puff/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/banner_layouts/package-puff/assets/javascripts/prescript.js');
"use strict";


svs.banner_layouts = svs.banner_layouts || {};
svs.banner_layouts.package_puff = svs.banner_layouts.package_puff || {};

 })(window);